<template>
  <div>
    <LoadingWidget v-if="loading" />

    <template v-else>
      <v-sheet class="py-10 py-md-13 py-lg-16 px-3 mx-auto" max-width="1200px">
        <TitleWidget>
          {{ title }}
        </TitleWidget>

        <template v-if="gallery.length || item.text">
          <img
            v-if="image && item.text"
            class="d-block mt-6 item-img"
            :src="files + image + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
            :alt="title"
            width="100%"
          />

          <div
            v-if="item.text"
            class="grey--text text-body-1 font-weight-regular mt-6 ck-content"
            v-html="item.text"
          ></div>

          <GallerySection
            v-if="gallery.length > 1"
            :has-title="!!item.text"
            :items="gallery"
          />
        </template>

        <v-alert v-else class="mt-6 mt-sm-8 mt-md-10" type="info">
          {{ noContentText }}
        </v-alert>
      </v-sheet>
    </template>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import GallerySection from "../components/sections/GallerySection.vue";

const _config = {
  mod: "about",
};

const _data = {
  loading: true,
  noContentText: "Nenhum conteúdo adicionado até o momento, volte mais tarde.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    itemId() {
      return this.$route.params.item;
    },
    item() {
      return this.$rest(_config.mod).item;
    },
    title() {
      return this.item.title || "Sobre";
    },
    image() {
      return this.item?.img?.featured?.path || "";
    },
    gallery() {
      if (this.item?.img?.list.length)
        return this.item.img.list.map(({ path, title }) => ({
          src: this.files + path,
          caption: title,
        }));

      return [];
    },
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  watch: {
    item() {
      document.title = `${this.title} | ${this.name}`;
    },
  },
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .finally(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    TitleWidget,
    GallerySection,
  },
};
</script>

<style lang="scss" scoped>
.item-img {
  max-height: 60vh;
  max-width: 100%;
  object-fit: contain;
}
</style>
